<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1918)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M18.5 35.9144C18.5 33.0568 20.7887 30.75 23.6 30.75H40.4C43.2113 30.75 45.5 33.0568 45.5 35.9144V51.25C45.5 51.5261 45.2761 51.75 45 51.75H19C18.7239 51.75 18.5 51.5261 18.5 51.25V35.9144Z"
    fill="url(#paint1_linear_1102_1918)"
    stroke="url(#paint2_linear_1102_1918)"
  />
  <path
    d="M23.5 18.625C23.5 14.1377 27.1377 10.5 31.625 10.5C36.1123 10.5 39.75 14.1377 39.75 18.625C39.75 23.1123 36.1123 26.75 31.625 26.75C27.1377 26.75 23.5 23.1123 23.5 18.625Z"
    fill="url(#paint3_linear_1102_1918)"
    stroke="url(#paint4_linear_1102_1918)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1918"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1918"
      x1="32"
      y1="30.25"
      x2="-0.20086"
      y2="46.2292"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1918"
      x1="41.2647"
      y1="28.5577"
      x2="30.0252"
      y2="41.7996"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1102_1918"
      x1="31.625"
      y1="10"
      x2="10.1644"
      y2="18.3675"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1102_1918"
      x1="37.3327"
      y1="8.67308"
      x2="28.4278"
      y2="16.9163"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
